import { isNetWorkGreaterThanLimit } from './per';

export function perfLog() {
  const { connectionThresholdTime, ttfbThreshold, fcpToTtfbRatio } = window.__global_config__ || {};
  // 过滤逻辑和数据参考文档： https://aliyuque.antfin.com/icbu-performance/ddprbu/nvk23olhbhifc5gn
  if (!isNetWorkGreaterThanLimit(connectionThresholdTime, ttfbThreshold, fcpToTtfbRatio)) {
    // load bb
    const bbScript = '//s.alicdn.com/@g/big-brother/sentry/3.x/index.js';
    const elScript = document.createElement('script');
    elScript.src = bbScript;
    document.getElementsByTagName('head')[0].appendChild(elScript);
  }
}
